/*
 * INTEGRATIONS
 */
export const BRAND_INTEGRATION_LIST = "brand_integration_list";
export const BRAND_INTEGRATION_STATS = "brand_integration_stats";
export const INTEGRATION = "integration";
export const INTEGRATIONS_URL = "integrations/brand/:brandId/integration";
export const INTEGRATION_BY_ID_URL = `integrations/brand/:brandId/integration/:integrationId`;
export const INTEGRATION_STATS_BY_ID_URL = `integrations/brand/:brandId/stats/:filter/:integrationId`;

export type newIntegrationType = {
  id: string;
  active: boolean;
  alias: string;
  name: string;
  settings: any;
  type: string;
  options: string[];
};

export type integrationCommonType = {
  active: boolean;
  alias: string;
  brand_id: number;
  created_at: string;
  id: number;
  name: string;
  type: string;
  updated_at: string;
  options: string[];
};

export type integrationType = integrationCommonType & {
  settings: any;
};

export type integrationListType = integrationType[];

/*
 * GATEWAYS
 */
export const BRAND_GATEWAY_LIST = "brand_gateway_list";
export const GATEWAYS_URL = "integrations/brand/:brandId/integration/gateways";

export const DEFAULT_TIME_LIMIT = 60;

export type gatewayListType = integrationCommonType[];

export enum GATEWAY_TYPE {
  SMS = "gateway:sms",
  EMAIL = "gateway:email",
  BLACKBOX = "gateway:blackbox",
  TELEGRAM = "gateway:telegram",
}

export const GATEWAYS = {
  PLIVO: {
    alias: "plivo",
    name: "Plivo",
    type: GATEWAY_TYPE.SMS,
  },
  BARABUT: {
    alias: "barabut",
    name: "Barabut",
    type: GATEWAY_TYPE.SMS,
  },
  MAILCHIMP: {
    alias: "mailchimp",
    name: "Mailchimp",
    type: GATEWAY_TYPE.EMAIL,
  },
  SMSTO: {
    alias: "smsto",
    name: "SMS.to",
    type: GATEWAY_TYPE.SMS,
  },
  TWILIO: {
    alias: "twilio",
    name: "Twilio",
    type: GATEWAY_TYPE.SMS,
  },
  IOVATION: {
    alias: "iovation",
    name: "iOvation",
    type: GATEWAY_TYPE.BLACKBOX,
  },
  COVERY: {
    alias: "covery",
    name: "Covery",
    type: GATEWAY_TYPE.BLACKBOX,
  },
  SENDGRID: {
    alias: "sendGrid",
    name: "SendGrid",
    type: GATEWAY_TYPE.EMAIL,
  },
  TELEGRAM: {
    alias: "telegram",
    name: "Telegram",
    type: GATEWAY_TYPE.TELEGRAM,
  },
  WAVIX: {
    alias: "wavix",
    name: "Wavix",
    type: GATEWAY_TYPE.SMS,
  },
  LAAFFIC: {
    alias: "laaffic",
    name: "LAAFFIC",
    type: GATEWAY_TYPE.SMS,
  },
};

export const gatewayOptions = [
  {
    label: GATEWAYS.PLIVO.name,
    value: GATEWAYS.PLIVO.alias,
  },
  {
    label: GATEWAYS.BARABUT.name,
    value: GATEWAYS.BARABUT.alias,
  },
  {
    label: GATEWAYS.MAILCHIMP.name,
    value: GATEWAYS.MAILCHIMP.alias,
  },
  {
    label: GATEWAYS.SMSTO.name,
    value: GATEWAYS.SMSTO.alias,
  },
  {
    label: GATEWAYS.TWILIO.name,
    value: GATEWAYS.TWILIO.alias,
  },
  {
    label: GATEWAYS.TELEGRAM.name,
    value: GATEWAYS.TELEGRAM.alias,
  },
  {
    label: GATEWAYS.IOVATION.name,
    value: GATEWAYS.IOVATION.alias,
  },
  {
    label: GATEWAYS.COVERY.name,
    value: GATEWAYS.COVERY.alias,
  },
  {
    label: GATEWAYS.SENDGRID.name,
    value: GATEWAYS.SENDGRID.alias,
  },
  {
    label: GATEWAYS.WAVIX.name,
    value: GATEWAYS.WAVIX.alias,
  },
  {
    label: GATEWAYS.LAAFFIC.name,
    value: GATEWAYS.LAAFFIC.alias,
  },
];
